<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" style="display: flex; justify-content: space-between;">
        <h3>Site and Parcel Exploration</h3>
    </div>
    <div class="panel-flat-body large">
        @if (serverAction) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        @if (!serverAction) {
            <div>
                <div class="d-flex align-items-center justify-content-between">
                    <div class="checkbox m-0 me-2">
                        @if (refreshingSites) {
                            <span>
                                <ws-ace-loader [inline]="true"></ws-ace-loader>&nbsp;Processing...
                            </span>
                        }
                        @if (!refreshingSites && !company?.parentId && this.company?.childCompanies?.length > 0) {
                            <label>
                                <input type="checkbox"
                                       [(ngModel)]="includeSubsidiarySites"
                                       (change)="includeSubsidiarySitesChanged()">Include
                                Sites for Subsidiaries
                            </label>
                        }
                        @if (!refreshingSites) {
                            <label class="ms-3">
                                <input type="checkbox" [(ngModel)]="activeOnly" (change)="getStatesWithSites()">Exclude Inactive
                            </label>
                        }
                    </div>
                    @if (hasWritePermission && !isConsultantPerspective) {
                        <button class="ace-btn btn-primary btn-sm" (click)="addSite()">Add Site</button>
                    }
                </div>
                <hr/>
                @if (states?.length) {
                    <div>
<!--                        <h4>{{ (activeOnly ? `Active` : '') }} Sites by State</h4>-->
                        <div class="row">
                            @for (state of states; track state) {
                                <button class="ace-btn btn-sm btn-secondary col-lg-1"
                                        (click)="doQuickSearch(state)">
                                    {{ state }}
                                </button>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
